// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__NBkQK","top":"profile_top__3_Tu6","avatar":"profile_avatar__XLYZA","name":"profile_name__3P_dN","users":"profile_users__3vJSv"};